<template>
  <div class="group_list">
    <div class="shadow search-wrap">
      <el-date-picker size="medium" class="search-inp" unlink-panels @change="pickerChange"
        :picker-options="pickerOptions" :default-value="timeDefaultShow" v-model="date" type="daterange"
        range-separator="-" :start-placeholder="$t('common_00312')" :end-placeholder="$t('common_00313')">
      </el-date-picker>
      <el-button type="primary" size="medium" class="search" icon="el-icon-search" @click="search">
        {{ $t("common_00255") }}
      </el-button>
    </div>
    <div class="list-top-wrap">
      <div class="title">{{$t("common_76001")}}</div>
    </div>
    <div class="content-wrap">
      <div class="table-wrap">
        <el-table v-loading="loading" style="width: 100%" :data="tableData" :header-cell-style="{
          height: '54px',
          fontSize: '14px',
          background: '#EFF2F6',
          color: '#1B2330',
          borderRadius: '4px 4px 0px 0px'
        }">
          <el-table-column :formatter="formmatTime" :label="$t('common_76002')" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="$t('common_76003',[$t(currencyType)])">
            <template slot-scope="scope">
              <span>{{ getChargeAmount(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common_76004')">
            <template slot-scope="scope">
              <p>{{ scope.row.title || "" }}</p>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div class="page">
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
            layout="total, prev, pager, next, jumper" :total="dataNum">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  requestUrl,
  ajax,
  checkLogin,
  getQueryString,
} from "@/assets/utils/network";
import {
  formmatTime,
  formmatNumFix2,
  getBjTimeFromLocalTime,
} from "@/assets/utils/time.js";
export default {
  data() {
    return {
      product: "",
      currencyType: "",
      id: "",
      loading: true,
      // 日期
      date: "",
      // 开始日期
      startTime: "",
      // 结束日期
      endTime: "",
      // 默认日期
      timeDefaultShow: new Date(),
      // 禁止选择今天以后的日期
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      loading: false,
      tableData: [],
      dataNum: 0,
      currentPage: 1,
    };
  },
  created: function () {
    var currencyType = checkLogin("currencyType");
    this.currencyType = currencyType ? currencyType : "cny";
    const today = new Date();
    const lastMonth = new Date(today);
    lastMonth.setMonth(today.getMonth() - 1);
    this.date = [lastMonth, today]
    this.startTime = this.date[0];
    this.endTime = this.date[1];
    this.product = window.product_area;
    this.id = getQueryString("id");
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      let url = `${requestUrl}/group/member/allocate/detail?userId=${this.id}&from=${(parseInt(this.currentPage) - 1) * 10}&length=10&returnCount=true${this.getTime()}`
      ajax({
        type: "GET",
        url: url,
        dataType: "json",
        async: false,
        success: (response) => {
          this.loading = false;
          this.tableData = JSON.parse(response).result;
          this.dataNum = JSON.parse(response).totalCount;
        },
      });
    },
    handleCurrentChange(val) {
      var page = `${val}`;
      if (this.currentPage == page) {
        return;
      }
      this.currentPage = Number(page);
      this.getList();
    },
    // 时间选择器时间变化
    pickerChange(val) {
      this.startTime = val ? val[0] : "";
      this.endTime = val ? val[1] : "";
    },
    // 格式化时间选择器选出来的时间
    getTime() {
      var url = "";
      if (this.startTime != "" && this.startTime != null) {
        var start =
          "" +
          this.startTime.getFullYear() +
          (this.startTime.getMonth() + 1 < 10
            ? "0" + (this.startTime.getMonth() + 1)
            : this.startTime.getMonth() + 1) +
          (this.startTime.getDate() < 10
            ? "0" + this.startTime.getDate()
            : this.startTime.getDate()) +
          "000000";
        start = getBjTimeFromLocalTime(start);
        url = url + "&startTime=" + start;
      }
      if (this.endTime != "" && this.endTime != null) {
        var end =
          "" +
          this.endTime.getFullYear() +
          (this.endTime.getMonth() + 1 < 10
            ? "0" + (this.endTime.getMonth() + 1)
            : this.endTime.getMonth() + 1) +
          (this.endTime.getDate() < 10
            ? "0" + this.endTime.getDate()
            : this.endTime.getDate()) +
          "235959";
        end = getBjTimeFromLocalTime(end);
        url = url + "&endTime=" + end;
      }
      return url;
    },
    // 搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    // 充值总金额
    getChargeAmount(row) {
      var amount = row.amount;
      return this.formmatNumFix2(amount);
    },
    // 金额转换
    formmatNumFix2(num) {
      return formmatNumFix2(num);
    },
    // 格式化充值日期
    formmatTime(row) {
      return formmatTime(row.createTime, true);
    },
  },
};
</script>

<style lang="scss" scoped>
.shadow {
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(30, 30, 30, 0.05);
  border-radius: 6px;
  margin-top: 20px;
  padding: 0 16px;
}

.el-button {
  font-weight: 600;
}

.el-button+.el-button {
  margin-left: 20px;
}

.search-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 66px;

  .search-inp {
    // width: 216px;
  }

  .search {
    /deep/i {
      font-weight: 600;
    }
  }
}

.list-top-wrap {
  margin-top: 20px;
  height: 62px;
  padding: 0 16px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom: 1px dashed #e6e7ec;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    font-weight: 600;
    color: #41526d;
    font-size: 16px;
  }
}

.content-wrap {
  position: relative;
  background-color: #fff;
  border-radius: 6px 6px 0 0;
  box-shadow: 0px 2px 12px 0px rgba(30, 30, 30, 0.05);

  .table-wrap {
    position: absolute;
    width: 100%;
    padding: 20px;
    background-color: #fff;
    box-sizing: border-box;
    margin-bottom: 20px;

    .operation {
      margin-right: 40px;
    }
  }
}

/*
* 分页器
*/
.page {
  width: inherit;
  height: auto;
  margin-top: 30px;
  text-align: center;
}
</style>
